import * as React from 'react';
import { IconProps } from '../types';

const IcCashierAccount = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <circle cx={12.5} cy={6.2} r={3.289} fill={props?.fill ?? '#232F3E'} />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M5.922 20.178h13.156l-.366-5.193-1.461-2.164-4.02-.865-4.02.432-2.923 3.03-.366 4.76ZM12.5 10.722a4.111 4.111 0 1 1 0-8.223 4.111 4.111 0 0 1 0 8.223Zm0-6.578a2.467 2.467 0 1 0 0 4.934 2.467 2.467 0 0 0 0-4.934Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M19.16 21H5.84a.705.705 0 0 1-.523-.24.87.87 0 0 1-.217-.582V17.71c0-1.744.624-3.417 1.734-4.651 1.11-1.234 2.616-1.927 4.186-1.927h2.96c1.57 0 3.076.693 4.186 1.927 1.11 1.233 1.734 2.906 1.734 4.651v2.467a.87.87 0 0 1-.217.581.704.704 0 0 1-.523.241ZM6.58 19.355h11.84v-1.644c0-1.308-.468-2.563-1.3-3.488-.833-.926-1.963-1.445-3.14-1.445h-2.96c-1.178 0-2.307.52-3.14 1.445-.832.925-1.3 2.18-1.3 3.488v1.645Z"
    />
  </svg>
);

export default IcCashierAccount;
